import { Flex } from "antd";
import Search from "antd/es/input/Search";
import { debounce } from "lodash";
import { FC, useEffect, useMemo, useState } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

interface MarketsSearchInputProps {
    fetchMarkets: (query: string) => void;
    loading: boolean;
}

export const MarketsSearchInput: FC<MarketsSearchInputProps> = ({
    fetchMarkets,
    loading,
}) => {
    const [searchValue, setSearchValue] = useState("");

    const debouncedSearch = useMemo(() => {
        const fn = debounce(async (value: string) => {
            if (value.length > 0 && value.length < 4) return;

            fetchMarkets(value);
        }, 500);

        return fn;
    }, [fetchMarkets]);

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    return (
        <Flex vertical gap={4}>
            <Search
                placeholder="Введіть назву або адресу магазину"
                allowClear
                size="large"
                onChange={(e) => {
                    const value = e.target.value;

                    setSearchValue(value);

                    debouncedSearch(value);
                }}
                loading={loading}
            />

            {searchValue.length > 0 && searchValue.length < 4 && (
                <PrimaryText $textColor="error">
                    Мінімум 4 символи для пошуку
                </PrimaryText>
            )}
        </Flex>
    );
};
